module.exports = __webpack_public_path__ + "media/navi/photo_keyflow_3-74d77fe1.png";